import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import WeelodgeInfoContent from './WeelogeInfoContent';
import WeelodgeMetadata from '../proptype/weelodgeMetadata';
import { newFormatPrice } from '../../../services/utilityFunctions';
import WeelodgeAgentsInfo from './WeelogeAgentsInfo';

function WeelodgeInfo({ t, info }) {
  let commissionValue = null;
  if (info?.agencyCommission >= 0) {
    commissionValue = `${newFormatPrice(
      info.agencyCommission,
      true,
      info?.agencyCommissionCurrency || 'EUR',
      true,
    )} (${t('checkout.payment.vatExcl')})`;
  }

  return (
    <div>
      {info?.reference && (
        <div className="reference">
          <span>{`${t('weelodge.modal.reference')}: `}</span>
          <span>{info.reference}</span>
        </div>
      )}
      {/** AGENCY COMMISSION */}
      {info?.agencyCommission && commissionValue && (
        <div className="container">
          <WeelodgeInfoContent
            label={t('weelodge.modal.commission')}
            value={commissionValue}
          />
        </div>
      )}
      {/** TYPE OF GOODS / CITY */}
      {(info?.goodsType || info?.city) && (
        <div className="container">
          <div className="container-grid">
            {/** GOODS */}
            {info?.goodsType && (
              <WeelodgeInfoContent
                label={`${t('weelodge.modal.goodsType')}:`}
                value={info.goodsType}
              />
            )}
            {/** CITY */}
            {info?.city && (
              <WeelodgeInfoContent
                label={`${t('weelodge.modal.city')}:`}
                value={info.city}
              />
            )}
          </div>
        </div>
      )}
      {/** SELLERS / BUYERS */}
      {(info?.sellers?.length > 0 || info?.buyers?.length > 0) && (
        <div className="container">
          <div className="container-grid">
            {/** SELLERS */}
            {info?.sellers?.length > 0 && (
              <WeelodgeInfoContent
                label={`${t('weelodge.modal.sellers')}:`}
                value={info.sellers}
                isArray
              />
            )}
            {/** BUYERS */}
            {info?.buyers?.length > 0 && (
              <WeelodgeInfoContent
                label={`${t('weelodge.modal.buyers')}:`}
                value={info.buyers}
                isArray
              />
            )}
          </div>
        </div>
      )}
      {/** AGENTS INFO */}
      {(info?.agentsSellers?.length > 0 || info?.agentsFinders?.length > 0) && (
        <WeelodgeAgentsInfo
          agencyCommission={info.agencyCommission}
          agencyCommissionCurrency={info.agencyCommissionCurrency}
          sellers={info.agentsSellers}
          finders={info.agentsFinders}
          sparringProgram={info.sparringProgram}
        />
      )}
    </div>
  );
}

WeelodgeInfo.propTypes = {
  t: PropTypes.func.isRequired,
  info: PropTypes.shape(WeelodgeMetadata.propType).isRequired,
};

WeelodgeInfo.defaultProps = {};

export default translate(WeelodgeInfo);
